import { useCallback, useEffect } from 'react';

import { USER_AGENT_DEV_MODE_TOKEN } from '../../constants';

export type TypeCheckNetworkStatusResponse = {
  /** 앱에 연결 여부 확인 요청을 보내는 트리거 */
  requestNetworkConnectivityByApp: () => Promise<boolean>;
};

/** 앱 브릿지를 통해 네트워크 연결 여부 확인 */
export const useCheckNetworkStatus = (): TypeCheckNetworkStatusResponse => {
  const isDevMode = navigator.userAgent === USER_AGENT_DEV_MODE_TOKEN;

  // 네트워크 연결 상태 확인 함수
  const getNetworkConnectivityByApp = useCallback((): Promise<boolean> => {
    return new Promise((resolve) => {
      try {
        if (isDevMode) {
          resolve(true);
        }
        // 네트워크 연결 결과를 받는 핸들러
        window.onNetworkConnectivityResult = (isConnect: string) => {
          const connectionStatus = String(isConnect) === 'true';
          resolve(connectionStatus);
        };

        if (window.JSBridge) {
          window.JSBridge.getNetworkConnectivity();
        }
        if (window.webkit) {
          window.webkit?.messageHandlers.getNetworkConnectivity?.postMessage(null);
        }
      } catch (error) {
        console.error(error);
        resolve(false);
      }
    });
  }, []);

  useEffect(() => {
    return () => {
      window.onNetworkConnectivityResult = null;
    };
  }, []);

  return { requestNetworkConnectivityByApp: getNetworkConnectivityByApp };
};
